"use strict";
var Observable_1 = require('../../Observable');
var onErrorResumeNext_1 = require('../../operator/onErrorResumeNext');
Observable_1.Observable.prototype.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNext;
//# sourceMappingURL=onErrorResumeNext.js.map


//////////////////
// WEBPACK FOOTER
// /app/SPA/~/rxjs/add/operator/onErrorResumeNext.js
// module id = ../../../../rxjs/add/operator/onErrorResumeNext.js
// module chunks = 4